import { SVGProps } from "react"
const FormSuccessNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    {...props}
  >
    <path
      d="M60.5 30.4701V33.0001C60.4966 38.9303 58.5764 44.7005 55.0257 49.4501C51.475 54.1998 46.484 57.6744 40.7972 59.3558C35.1104 61.0373 29.0325 60.8353 23.4698 58.7802C17.9071 56.7251 13.1578 52.9269 9.93014 47.9521C6.70248 42.9772 5.16943 37.0923 5.55961 31.175C5.9498 25.2577 8.24232 19.625 12.0953 15.1171C15.9482 10.6091 21.1552 7.46742 26.9395 6.16052C32.7239 4.85362 38.7757 5.45154 44.1925 7.86512"
      stroke={props.color || "#008015"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M60.5 11L33 38.5275L24.75 30.2775"
      stroke={props.color || "#008015"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default FormSuccessNewIcon
